import React, { useState, useContext } from 'react'
import {
  Table,
  Button,
  Spinner,
  Badge
} from "reactstrap";
import { generatePdfApi } from '../../api/quotationApi'
import { generateExcel } from '../../components/common/excelConverter/ExcelConverter'
import { AuthContext } from "../../contexts/AuthContext";
import moment from 'moment';
function QuoteList({quotations, fetchSingleQuotation}) {
  const { authToken } = useContext(AuthContext);
  const [isLoadingRowPdf , setIsLoadingRowPdf] = useState({});
  const [isLoadingRowExcel , setIsLoadingRowExcel] = useState({});

  const generatePdf = async (quotId, quotRefNumber, subject, version) => {
      try{
        setIsLoadingRowPdf((prev)=>{
          return {[quotId] : true }
        });
        await generatePdfApi(quotId, quotRefNumber, subject, version)
        setIsLoadingRowPdf((prev)=>{
          return {[quotId] : false}
        });
      }catch(error){

      }
  };

  const generateStatement = async (token, quoteId )=>{
    try{
      if(!token){
        throw new Error('Token not found.')
      }
      setIsLoadingRowExcel((prev)=>{
        return {[quoteId] : true}
      })
      await generateExcel(token, quoteId)
      setIsLoadingRowExcel((prev)=>{
        return {[quoteId] : false}
      })
    }catch(error){
      console.log("Error", error.message);
      
    }
  }
  return (
<div className="table-responsive">
  <Table striped>
    <thead>
      <tr>
        <th>S.No.</th>
        <th style={{ whiteSpace: 'nowrap' }}>Quot Ref No</th>
        <th style={{ whiteSpace: 'nowrap' }}>Crm Ref No</th>
        <th>Customer Name</th>
        <th style={{ whiteSpace: 'nowrap' }}>Subject</th>
        <th style={{ whiteSpace: 'nowrap' }}>Version</th>
        <th style={{ whiteSpace: 'nowrap' }}>Created by</th>
        <th style={{ whiteSpace: 'nowrap' }}>Salesperson</th>
        <th style={{ whiteSpace: 'nowrap' }}>Created At</th>
        <th style={{ whiteSpace: 'nowrap' }}>Actions</th>
      </tr>
    </thead>
    <tbody>
      {quotations?.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{item.quote_ref_number}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{item.crm_ref_number}</td>
          <td>{item.customer_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{item.subject}</td>
          <td>
            <Badge color="info">{item.version ? `V${item.version}` : ''}</Badge>
          </td>
          <td style={{ whiteSpace: 'nowrap' }}>{item.user_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{item.user_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>
            {moment(item.created_at).format('DD MMM YYYY')}
          </td>
          <td>
            <div className="d-flex flex-wrap" style={{ gap: '0.5rem' }}>
              {/* EDIT */}
              <Button
                color="success"
                type="button"
                style={{ whiteSpace: 'nowrap' }}
                className="me-3"
                onClick={() => fetchSingleQuotation(item.id)}
              >
                <span>Edit Quotation</span>
              </Button>
              {/* PDF */}
              <Button
                disabled={isLoadingRowPdf[item.id]}
                color="danger"
                style={{ whiteSpace: 'nowrap' }}
                className="me-3"
                type="button"
                onClick={() =>
                  generatePdf(item.id, item.quote_ref_number, item.subject, item.version)
                }
              >
                {isLoadingRowPdf[item.id] ? (
                  <>
                    <Spinner size="sm">Loading...</Spinner>
                    <span> Loading</span>
                  </>
                ) : (
                  <>
                    Download PDF <i className="bi bi-file-earmark-pdf-fill"></i>
                  </>
                )}
              </Button>
              {/* Excel */}
              <Button
                color="success"
                disabled={isLoadingRowExcel[item.id]}
                style={{ whiteSpace: 'nowrap' }}
                type="button"
                onClick={() => generateStatement(authToken, item.id)}
              >
                {isLoadingRowExcel[item.id] ? (
                  <>
                    <Spinner size="sm">Loading...</Spinner>
                    <span> Loading</span>
                  </>
                ) : (
                  <>
                    Download Statement <i className="bi bi-file-earmark-excel-fill"></i>
                  </>
                )}
              </Button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
</div>

  )
}

export default QuoteList
